module.exports = __webpack_public_path__ + "fonts/Lexend-Regular.e7e7aa8.woff2";